import Swiper from "swiper";

const sliderOptions = {
  slidesPerView: 1,
  speed: 300,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  }
};

const state = {
  elements: {},
  initialSlide: 0,
};

const openModal = () => {
  state.elements.galleryModal.classList.add("show");
  state.elements.body.classList.add("overflow-hidden");
};

const checkAndAddOrRemoveClassName = (el, className) => {
  if (el.classList.contains(className)) {
    el.classList.remove(className);
    return;
  }
  el.classList.add(className);
}

const setActiveSlideToWindowUrl = (activeIndex) => {
  const { href } = window.location;
  const url = new URL(href);
  url.searchParams.set("activeSlide", activeIndex);
  window.history.replaceState({}, "", url);
};

const scrollToTheItemById = (id) => {
  state.elements.allImageContainers[id].scrollIntoView({ block: "center", inline: "center" });
};

const cacheElements = () => {
  const containerVideo = document.querySelector('.video-section');
  const containerGallery = document.querySelector('.image-gallery');
  state.elements = {
    containerVideo,
    containerGallery,
    swiperContainer: containerGallery.querySelector(".gallery-swiper"),
    descControlBtn: containerVideo.querySelector("[data-toggle-show]"),
    desc: containerVideo.querySelector(".desc"),
    allImageContainers: containerGallery.querySelectorAll("[data-image]"),
    galleryModal: containerGallery.querySelector(".image-gallery-modal"),
    closeBtn: containerGallery.querySelector("[data-close]"),
    prevButton: containerGallery.querySelector(".swiper-button-prev"),
    nextButton: containerGallery.querySelector(".swiper-button-next"),
    body: document.querySelector("body"),
  };
};

const attachListeners = () => {
  state.elements.descControlBtn.addEventListener("click", () => {
    const currentState = state.elements.descControlBtn.getAttribute("data-toggle-show");
    const isLess = currentState === "less";

    if (isLess) {
      state.elements.descControlBtn.textContent = state.elements.descControlBtn.getAttribute("data-less");
      state.elements.descControlBtn.setAttribute("data-toggle-show", "more");
    } else {
      state.elements.descControlBtn.textContent = state.elements.descControlBtn.getAttribute("data-more");
      state.elements.descControlBtn.setAttribute("data-toggle-show", "less");
    }
    checkAndAddOrRemoveClassName(state.elements.desc, "show-less");
  })
  state.elements.closeBtn.addEventListener("click", () => {
    state.elements.galleryModal.classList.remove("show");
    state.elements.body.classList.remove("overflow-hidden");
  });
};

const initSwiper = (initialSlide) => {
  if (initialSlide) {
    openModal();
    scrollToTheItemById(initialSlide - 1);
    sliderOptions.initialSlide = initialSlide - 1;
    if (initialSlide === "1") {
      state.elements.prevButton.classList.add("hidden");
    }
  } else {
    state.elements.prevButton.classList.add("hidden");
  }

  const swiperWrapper = document.querySelector(".swiper-wrapper");
  // create swiper slides
  const images = Array.from(state.elements.allImageContainers).map((imageContainer) => {
    const image = imageContainer.querySelector("img");
    const { title, subtitle, description } = imageContainer.dataset;
    return `<div class="swiper-slide">
      <div class="swiper-image">
        ${image.outerHTML}
      </div>
      <div class="gallery-details">
        ${title ? `
          <div class="gallery-details__title">
            <p>${title}</p>
          </div>
        ` : ""}
        ${subtitle ? `
          <div class="gallery-details__subtitle">
            <p>${subtitle}</p>
          </div>
        ` : ""}
        ${description ? `
          <div class="gallery-details__desc">
            ${description}
          </div>
        ` : ""}
      </div>
    </div>`;
  }).join("");

  // add slides to swiper wrapper
  swiperWrapper.innerHTML = images;

  // init swiper
  const gallerySwiper = new Swiper(
    state.elements.swiperContainer,
    {
      ...sliderOptions,
    }
  );

  state.elements.allImageContainers.forEach((imageContainer, index) => {
    imageContainer.addEventListener("click", () => {
      openModal();
      gallerySwiper.slideTo(index, 0);
    })
  });

  // add event listeners
  state.elements.nextButton.addEventListener("click", () => {
    gallerySwiper.slideNext();
  });
  state.elements.prevButton.addEventListener("click", () => {
    gallerySwiper.slidePrev();
  });

  // on slider change, hide or show buttons
  gallerySwiper.on("slideChange", () => {
    const { isBeginning, isEnd, activeIndex } = gallerySwiper;
    if (isBeginning) {
      state.elements.prevButton.classList.add("hidden");
    } else if (isEnd) {
      state.elements.nextButton.classList.add("hidden");
    } else {
      state.elements.prevButton.classList.remove("hidden");
      state.elements.nextButton.classList.remove("hidden");
    }

    // add current index to the window query params
    setActiveSlideToWindowUrl(activeIndex + 1);
    scrollToTheItemById(activeIndex);
  });
};

const initLookbook = (currentSlide) => {
  cacheElements();
  attachListeners();
  initSwiper(currentSlide);
};

export default initLookbook;